import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

const getPositionFromBrowser = (locationTimeout, cacheDuration) => {
  const options = {
    maximumAge: cacheDuration * 24 * 60 * 60 * 1000,
    timeout: locationTimeout
  };
  const timeout = setTimeout(() => null, locationTimeout);
  return new Promise(resolve => {
    navigator.geolocation.getCurrentPosition(position => {
      clearTimeout(timeout);
      return resolve(position.coords);
    }, () => {
      clearTimeout(timeout);
      return resolve({});
    }, options);
  });
};

const getBrowserPosition = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* ({
    locationTimeout = 10000,
    cacheDuration = 7
  }) {
    if (navigator.geolocation) {
      return getPositionFromBrowser(locationTimeout, cacheDuration);
    }

    return null;
  });

  return function getBrowserPosition(_x) {
    return _ref.apply(this, arguments);
  };
}();

export default getBrowserPosition;